import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBusinessServices,
  fetchSalonDetails,
} from "../../../redux/adminReducer";
import Loader from "../../../common/loader";
import Modal from "../../../common/modal";
function SalonInfo() {
  const { salonId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState("");
  const [activeCategory, setActiveCategory] = useState(0);
  const [loading, setLoading] = useState(false);
  const { translations, dir } = useSelector((state) => state.language);
  const dispatch = useDispatch();

  const salonDetails = useSelector(
    (state) => state.admin.salonDetails?.data || {}
  );

  const serviceCategories = useSelector(
    (state) => state.admin.businessServices?.data || []
  );

  useEffect(() => {
    setLoading(true);
    dispatch(fetchSalonDetails(salonId)).then(() => {
      setLoading(false);
    });
    dispatch(fetchBusinessServices(salonId));
  }, [dispatch, salonId]);
  const BASE_URL = process.env.REACT_APP_BASE_URL || "https://jeema.co/api/v2/";
  const isPdfFile = (url) => /\.pdf$/i.test(url);

  // Handle logo
  const logo = salonDetails?.business_logo
    ? `${BASE_URL}${encodeURIComponent(salonDetails.business_logo)}`
    : `${BASE_URL}${encodeURIComponent("brand/Image.jpg")}`;

  // Handle registration documents (PDFs or Images)
  const documentUrls =
    salonDetails?.registration_document?.map(
      (doc) => `${BASE_URL}${encodeURIComponent(doc)}`
    ) || [];

  // First document preview (used as a default thumbnail)
  const documentPic = salonDetails?.registration_document?.[0]
    ? `${BASE_URL}${encodeURIComponent(salonDetails.registration_document[0])}`
    : `${BASE_URL}${encodeURIComponent("brand/Image.jpg")}`;

  // Photos/images of the salon
  const images = salonDetails?.photos || [];

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.salon_info.salonDetails}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.salon_info.salonRequestManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.salon_info.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <Link
                  to="/salon-request"
                  className="text-white  no-underline cursor-pointer"
                >
                  {translations.salon_info.salonRequest}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.salon_info.salonDetails}{" "}
                </span>
              </div>
            </div>
          </section>
          {loading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-1 gap-4 mt-4">
              {/* Top Row: Basic Info + Document Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Basic Details */}
                <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.basicDetails}
                  </h3>

                  <div className="flex items-center gap-6">
                    <img
                      src={logo}
                      alt="Salon Logo"
                      className="h-40 w-40 object-cover rounded-lg"
                    />
                    <div>
                      <h2 className="text-xl font-bold text-white">
                        {salonDetails.business_name}
                      </h2>
                      {salonDetails.website_url && (
                        <a
                          href={salonDetails.website_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-400 text-sm hover:underline"
                        >
                          {salonDetails.website_url}
                        </a>
                      )}
                      <p className="mt-1 text-gray-300 text-sm">
                        {salonDetails.bio}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Document Details */}
                <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.documentDetails}
                  </h3>

                  <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                    {/* 📄 Icon Box */}
                    <div className="relative group">
                      <div
                        className="h-40 w-40 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center cursor-pointer transition relative"
                        onClick={() => setIsModalOpen(true)}
                      >
                        {/* Tooltip appears below the icon */}
                        <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 hidden group-hover:block whitespace-nowrap bg-black text-white text-xs px-2 py-1 rounded shadow">
                          View Documents
                        </div>

                        <span className="text-5xl">📄</span>
                      </div>
                    </div>
                    <ul className="text-white space-y-3 w-full">
                      <li className="flex items-start">
                        <span className="text-gray-400 w-40">
                          {translations.salon_info.commercialId}:
                        </span>
                        <span>{salonDetails.commercial_id}</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-gray-400 w-40">
                          {translations.salon_info.registrationNo}:
                        </span>
                        <span>{salonDetails.registration_number}</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-gray-400 w-40">
                          {translations.salon_info.registarationVerified}:
                        </span>
                        <span className="text-red-400">
                          {salonDetails?.registration_rejected_reason &&
                          salonDetails?.registration_rejected_reason.length > 0
                            ? translations.salon_info.rejected
                            : translations.salon_info.no}
                        </span>
                      </li>
                      {salonDetails?.registration_rejected_reason &&
                        salonDetails?.registration_rejected_reason?.length >
                          0 && (
                          <li className="flex items-start">
                            <span className="text-gray-400 w-40">
                              {translations.salon_info.reason}:
                            </span>
                            <span className="text-red-400">
                              {salonDetails.registration_rejected_reason}
                            </span>
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Middle Row: Salon Info + Business Hours + Contact */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Salon Info */}
                <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.salonInfo}
                  </h3>
                  <ul className="text-white space-y-3">
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.teamSize}:
                      </span>
                      <span className="whitespace-pre-line break-words">
                        {salonDetails.team_size ||
                          translations.salon_info.notAvailable}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.genderService}:
                      </span>
                      <span className="whitespace-pre-line break-words">
                        {salonDetails.gender_services?.join(", ")}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.businessType}:
                      </span>
                      <span>
                        {salonDetails.business_type === 0
                          ? translations.salon_info.individual
                          : translations.salon_info.commercial}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.homeService}:
                      </span>
                      <span>
                        {salonDetails.home_service === 0
                          ? translations.salon_info.available
                          : translations.salon_info.notAvailable}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.salonStatus}:
                      </span>
                      <span>
                        {salonDetails.salon_status === 301
                          ? "Available"
                          : "Offline"}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-32 shrink-0">
                        {translations.salon_info.categories}:
                      </span>
                      <span className="whitespace-pre-line break-words">
                        {salonDetails.multiple_category
                          ?.map((cat) => cat.category_name)
                          .join(", ")}
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Business Hours */}
                <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.businessHours}
                  </h3>
                  {salonDetails?.business_hours?.length > 0 ? (
                    <ul className="text-white space-y-3">
                      {salonDetails.business_hours.map((hour) => (
                        <li key={hour._id} className="flex items-start">
                          <span className="text-gray-400 w-28">
                            {hour.day}:
                          </span>
                          <span>
                            {hour.is_open
                              ? `${hour.opening_time} - ${hour.closing_time}`
                              : translations.salon_info.closed}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-white">
                      {translations.salon_info.noBusiness}
                    </p>
                  )}
                </div>

                {/* Contact */}
                <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.contactDetails}
                  </h3>
                  <ul className="text-white space-y-3">
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-24 shrink-0">
                        {translations.salon_info.email}:
                      </span>
                      <span className="break-words">
                        {salonDetails.email || "Not Available"}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-24 shrink-0">
                        {translations.salon_info.address}:
                      </span>
                      <span className="whitespace-pre-line break-words">
                        {salonDetails.address}
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-24 shrink-0">
                        {translations.salon_info.zipcode}:
                      </span>
                      <span>{salonDetails.zipcode}</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-400 w-24 shrink-0">
                        {translations.salon_info.country}:
                      </span>
                      <span>{salonDetails.country_name}</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span
                        className="text-gray-400 w-24 shrink-0"
                        style={{ direction: "ltr" }}
                      >
                        {translations.salon_info.phone}:
                      </span>
                      <span style={{ direction: "ltr" }}>
                        {salonDetails.business_phone}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Salon Images */}
              <div className="bg-gray-800 rounded-xl p-6 shadow-md">
                <h3 className="text-lg font-semibold text-white mb-4">
                  {translations.salon_info.salonImages}
                </h3>

                {images.length > 0 ? (
                  <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    className="h-[400px] w-full"
                  >
                    {images.map((path, index) => (
                      <SwiperSlide key={index}>
                        <div className="flex h-full items-center justify-center">
                          <div className="relative h-[300px] w-full">
                            <img
                              src={`${BASE_URL}${encodeURIComponent(path)}`}
                              alt={`Salon pic ${index + 1}`}
                              className="rounded-lg object-contain w-full h-full"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <p className="text-white">
                    {translations.salon_info.noImage}
                  </p>
                )}
              </div>

              {/* Service Details Section */}
              {serviceCategories?.length > 0 && (
                <div className="bg-gray-800 rounded-xl p-6 shadow-md mt-4">
                  <h3 className="text-lg font-semibold text-white mb-4">
                    {translations.salon_info.serviceDetails}
                  </h3>

                  {/* Category Tabs */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {serviceCategories.map((category, index) => (
                      <button
                        key={category._id}
                        onClick={() => setActiveCategory(index)}
                        className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                          index === activeCategory
                            ? "bg-blue-500 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        {category.category_name}
                      </button>
                    ))}
                  </div>

                  {/* Services Swiper */}
                  {serviceCategories[activeCategory]?.services?.length > 0 ? (
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={20}
                      slidesPerView={1}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                      navigation
                    >
                      {serviceCategories[activeCategory].services.map(
                        (service) => (
                          <SwiperSlide key={service._id}>
                            <div
                              className="
                bg-gray-700 p-6 rounded-xl 
                flex flex-col justify-between
                h-[320px] sm:h-[350px] md:h-[400px] 
                overflow-hidden
              "
                            >
                              {/* Optional Service Image */}
                              {service.service_pic && (
                                <img
                                  src={`${BASE_URL}${encodeURIComponent(
                                    service.service_pic
                                  )}`}
                                  alt={service.service_name}
                                  className="h-24 w-full object-cover rounded-md mb-3"
                                />
                              )}

                              {/* Service Name */}
                              <h4 className="text-white font-semibold text-lg truncate mt-5">
                                {service.service_name}
                              </h4>

                              {/* Description */}
                              <p className="text-gray-300 text-sm  line-clamp-3 overflow-hidden">
                                {service.service_description?.trim()
                                  ? service.service_description
                                  : service.description}
                              </p>

                              {/* Status and Price */}
                              <div className="mt-4 text-gray-400 text-sm">
                                {service.is_active === false ? (
                                  <span className="text-red-400">Inactive</span>
                                ) : (
                                  <span className="text-green-400">Active</span>
                                )}
                                <br />
                                Price:{" "}
                                {service.price > 0
                                  ? `${service.price} ${service.currency || ""}`
                                  : "Free"}
                              </div>
                            </div>
                          </SwiperSlide>
                        )
                      )}
                    </Swiper>
                  ) : (
                    <p className="text-gray-300">
                      No services available for this category.
                    </p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </Layout>
      {/* <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          width="w-auto"
        >
          <img
            src={documentPic}
            alt="Full Document"
            className="w-full rounded-md object-contain"
          />
        </Modal> */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="w-[90%] md:w-[600px]"
      >
        <div className="mx-auto rounded-lg relative w-full max-w-2xl text-white">
          <h2 className="text-xl font-bold mb-4">Documents</h2>

          <div
            className="bg-gray-800 rounded flex items-center justify-center px-4"
            style={{ maxHeight: "70vh", minHeight: "60vh" }}
          >
            <div className="mx-auto rounded-lg relative w-full max-w-2xl text-white px-6 py-4">
              <div className="flex flex-col gap-4">
                {documentUrls.map((url, index) => (
                  <button
                    key={index}
                    onClick={() => window.open(url, "_blank")}
                    className="flex items-center gap-3 bg-gray-700 hover:bg-gray-600 transition-colors px-4 py-3 rounded-md text-left w-full"
                  >
                    <span className="text-white text-lg">📄</span>
                    <span className="text-white font-medium">
                      View Document {index + 1}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SalonInfo;
